import React, { PropTypes } from 'react'
import Section from './Section';
import TestimonialName from './TestimonialName';
import cx from 'classnames';
import data from '../../core/data';

const testimonial = data.testimonials;

const Testimonials = (props) => {
  return (
    <section id="testimonials">
      { CreateTestimonials() }
    </section>
  )
}

const CreateTestimonials = () => {
  return (
    testimonial.map((item, index) => {
      return (
        <Section className="testimonial" key={ index }>
          <blockquote className={cx("col-md-6 body",{
              "col-md-offset-6": index % 2 === 1 })}>
            <p>{ item.body }</p>
            <TestimonialName name={ item.name } />
          </blockquote>
        </Section>
      );
    })
  )
}

export default Testimonials;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Testimonials.jsx
 **/